import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils/request'

const initialState = {}

// 邀请码领取结果码（对齐 MooX_1.8.2_邀请码_技术方案 §5）
export type InviteRedeemStatus =
  | 'SUCCESS'
  | 'ALREADY_CLAIMED'
  | 'USER_NOT_NEW'
  | 'INVALID_CODE'
  | 'SELF_CODE'
  | 'INVITER_DISABLED'
  | 'REWARD_PENDING'
  | 'TOO_MANY_ATTEMPTS'

// GET 个人邀请码模块（技术方案 §3）
export interface InviteModuleData {
  invite_code: string
  // B 区（输入区）开关，false 时隐藏整个 B 区
  redeem_enabled: boolean
  // 双方各自可得张数，用于文案参数
  reward_amount: number
}

// 提交好友邀请码结果（技术方案 §4）
export interface InviteRedeemData {
  status: InviteRedeemStatus
  // 以下字段仅 SUCCESS 返回
  reward_amount?: number
  // 绑定成功弹窗内容，字段与每日签到一致，客户端复用 showDialogEvent 渲染
  // title / sub_title / negative_button_text 恒为空且 omitempty 不出现，须按可选处理
  type?: string
  top_icon_url?: string
  title?: string
  sub_title?: string
  content?: string
  positive_button_text?: string
  negative_button_text?: string
}

export const getFastpassCenter = createAsyncThunk<any, any>(
  'getFastpassCenter',
  async (arg) => {
    return req({
      url: '/api/quota/fastpass/center',
      params: {...arg},
    })
  }
)

export const getFastpassRecords = createAsyncThunk<any, any>(
  'getFastpassRecords',
  async (arg) => {
    return req({
      url: '/api/quota/fastpass/records',
      params: {...arg},
    })
  }
)

export const getFastpassTaskSignPick = createAsyncThunk<any, any>(
  'getFastpassTaskSignPick',
  async (arg) => {
    return req({
      url: '/api/quota/fastpass/task/signin',
      params: {...arg},
    })
  }
)
export const getFastpassTaskSharePick = createAsyncThunk<any, any>(
  'getFastpassTaskSharePick',
  async (arg) => {
    return req({
      url: '/api/quota/fastpass/task/share/pick',
      params: {...arg},
    })
  }
)

// 获取/生成当前用户的个人邀请码（技术方案 §3）
export const getFastpassInviteModule = createAsyncThunk<InviteModuleData, void>(
  'getFastpassInviteModule',
  async () => {
    return req({
      url: '/api/quota/fastpass/invite_module',
      params: {},
    })
  }
)

// 提交好友邀请码并完成双边发奖（技术方案 §4；仅传 invite_code）
export const redeemInviteCode = createAsyncThunk<
  InviteRedeemData,
  {invite_code: string}
>('redeemInviteCode', async (arg) => {
  return req({
    url: '/api/quota/fastpass/invite_redeem',
    params: {...arg},
  })
})

export const youSuTongSlice = createSlice({
  name: 'youSuTong',
  initialState,
  reducers: {},
  extraReducers: () => {},
})

export default youSuTongSlice.reducer
